import type { ReactNode } from 'react';

/**
 * One labelled figure inside a `<dl>`.
 *
 * Eight CADE pages carried a private copy of this, six of them byte-identical
 * and two lighter (no bold, one taking a node rather than a string) -- so a
 * change to how a figure reads reached at most one of them. One component,
 * with `emphasis` for the lighter form and `hint` for the second line a card
 * uses to say what its number does NOT include ("8.123 in the published
 * register", "464 final").
 *
 * The window a figure counts over is deliberately NOT a prop here: most Stats
 * sit inside an `<Answer>` whose population already frames them, and a window
 * repeated on every figure in a panel is noise. It belongs once per group, in
 * `WindowCaption`, and once per screen, in the strip.
 */
export function Stat({
  label,
  value,
  hint,
  emphasis = true,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  emphasis?: boolean;
}) {
  return (
    <div>
      <dt className="text-muted-foreground">{label}</dt>
      <dd
        className={
          emphasis
            ? 'mt-0.5 text-base font-semibold tabular-nums text-foreground'
            : 'tabular-nums text-foreground'
        }
      >
        {value}
      </dd>
      {hint ? <dd className="text-xs text-muted-foreground">{hint}</dd> : null}
    </div>
  );
}
